import React, { useEffect, useState } from "react";
import ChatBot from "react-simple-chatbot";
import { ThemeProvider } from 'styled-components';

import { SendSupportMail, GetUserEmail } from "../helper/aimsChatBotHelper";
import { getSessionData } from "../../base/helper/baseHelper";
import HeadsetImg from "./support.png";

const AimsChatBot = (props) => {

  const [query, setQuery] = useState("");
  const [email, setEmail] = useState("");
  // eslint-disable-next-line
  const [userId, setUserId] = useState(getSessionData({ key: "userId" }));
  const [supportNumber, setSupportNumber] = useState();

  useEffect(() => {
    if( email && email.length > 0) {
      handleEnd();
      setEmail("");
      setQuery("");
    }
    // eslint-disable-next-line
  },[email]);

  useEffect(() => {
    let supportNo = Math.floor((Math.random() * 1000) + 1);
    setSupportNumber(supportNo);
    if( query && query.length > 0 ) {  
      GetUserEmail(userId)
      .then(response => {
        setEmail(response[0].useremailid);
      })
      .catch(() => {});
    }
    // eslint-disable-next-line
  }, [query]);

  const handleEnd = () => {
    let data = { user_email : email, email_content : query, ticket_number : supportNumber}
    SendSupportMail(data)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    })
  }

  const steps = [
    {
      id: '1',
      message: "Welcome to AIMS, How can I help you?",
      trigger: '2',
    },
    {
      id: '2',
      options: [
        { value : 1, label: 'Create Support Ticket', trigger: '3' },
        { value : 2, label: 'Exit', trigger: '11' },
      ],
    },
    {
      id : '3',
      message: "Please mention your concern",
      trigger : '4'
    },
    {
      id: '4',
      user: true,
      validator: (value) => {
        if ( value.length === 0) {
          return 'This Field is required';
        }
        setQuery(value);
        return true;
      },
      trigger: "8",
    },
    {
      id: '8',
      message: `We have received your concern and logged the issue. Our support team with reach you shortly. The reference number has been sent to your registered email for future tracking.`,
      trigger: "9",
    },
    {
      id: '9',
      message: "Is there something else We can help you with?",
      trigger: "10",
    },
    {
      id: '10',
      options: [
        { value : 3, label: 'Yes', trigger: '2' },
        { value : 4, label: 'No', trigger: '11' },
      ],
    },
    {
      id: '11',
      message: "Thank you",
      trigger: "1",
    },
  ]
  
  const chatbotStyle = {
    floating: true,
  };

  const theme = {
    background: '#f5f8fb',
    headerBgColor: 'rgb(22, 177, 255)',
    botBubbleColor: 'rgb(22, 177, 255)',
    userBubbleColor: '#fff'
  };

  

  return (
    <ThemeProvider theme={theme}>
      <ChatBot
        headerTitle={"AIMS Support Assistant"}
        recognitionEnable={true}
        enableSmoothScroll={true}
        botAvatar={HeadsetImg}
        steps={steps}
        {...chatbotStyle}
      />
    </ThemeProvider>
  );
};
export default AimsChatBot;